import { getTheme } from './getTheme';
import type { Theme } from './restyle';
import type { ThemeSelection } from './types';

const DEFAULT_SELECTION: ThemeSelection = {
  mode: 'light',
  breakpoint: 'small',
};

/**
 * API publique du design system.
 * Retourne un thème Restyle construit à partir des tokens générés.
 */
export function createTheme(selection: Partial<ThemeSelection> = {}): Theme {
  return getTheme({
    ...DEFAULT_SELECTION,
    ...selection,
  }) as unknown as Theme;
}
